import { useDirectMessageStore } from '../../stores/directMessageStore.js';
import { useAeThex } from '../../components/AeThexProvider';

export default function DirectMessageList() {
  const { conversations, currentConversationId, setCurrentConversation } = useDirectMessageStore();
  const { user } = useAeThex();

  return (
    <div style={{ width: 240, background: 'rgb(var(--aethex-panel))', borderRight: '1px solid rgb(var(--aethex-border))', display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
      <div style={{ padding: '16px', borderBottom: '1px solid rgb(var(--aethex-border))' }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: 'rgb(var(--aethex-dim))', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 8 }}>Direct Messages</div>
        {user && (
          <div style={{ fontSize: 12, color: 'rgb(var(--aethex-muted))' }}>
            Logged in as <strong style={{ color: 'rgb(var(--aethex-text))' }}>{user.display_name || user.username}</strong>
          </div>
        )}
      </div>

      <div style={{ flex: 1, overflowY: 'auto' }}>
        {conversations.length === 0 ? (
          <div style={{ padding: 24, textAlign: 'center', color: 'rgb(var(--aethex-dim))', fontSize: 13 }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>💬</div>
            No conversations yet
          </div>
        ) : (
          conversations.map((conv) => (
            <button
              key={conv.id}
              onClick={() => setCurrentConversation(conv.id)}
              style={{
                width: '100%',
                padding: '10px 12px',
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                background: currentConversationId === conv.id ? 'rgb(var(--aethex-primary)/0.15)' : 'transparent',
                borderLeft: currentConversationId === conv.id ? '3px solid rgb(var(--aethex-primary))' : '3px solid transparent',
                borderTop: 'none',
                borderRight: 'none',
                borderBottom: '1px solid rgb(var(--aethex-border)/0.5)',
                cursor: 'pointer',
                textAlign: 'left',
                transition: 'background 0.15s',
              }}
              onMouseEnter={(e) => { if (currentConversationId !== conv.id) e.currentTarget.style.background = 'rgb(var(--aethex-surface))'; }}
              onMouseLeave={(e) => { if (currentConversationId !== conv.id) e.currentTarget.style.background = 'transparent'; }}
            >
              <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg, rgb(var(--aethex-primary)/0.8), rgb(var(--aethex-primary)/0.4))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0 }}>
                {conv.avatar}
              </div>

              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: 'rgb(var(--aethex-text))', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{conv.userName}</div>
                <div style={{ fontSize: 11, color: 'rgb(var(--aethex-dim))', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{conv.lastMessage || 'No messages yet'}</div>
              </div>

              {conv.unread > 0 && (
                <div style={{ background: '#ef4444', color: '#fff', fontSize: 11, fontWeight: 700, borderRadius: 9999, minWidth: 20, height: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 5px', flexShrink: 0 }}>
                  {conv.unread}
                </div>
              )}
            </button>
          ))
        )}
      </div>

      <div style={{ padding: 12, borderTop: '1px solid rgb(var(--aethex-border))' }}>
        <button style={{ width: '100%', background: 'rgb(var(--aethex-primary)/0.15)', border: '1px solid rgb(var(--aethex-primary)/0.3)', color: 'rgb(var(--aethex-primary))', borderRadius: 8, padding: '8px 12px', cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>
          + New Message
        </button>
      </div>
    </div>
  );
}
